import axios from "axios";

export const onboardingComplete = async () => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API}/User/onboarding-complete`
    );
    return response;
  } catch (error: any) {
    console.error(error);
    return error.response;
  }
};
